export default __webpack_public_path__ + "static/media/Astro_Opposition_Black.302749d2.png";